// extracted by mini-css-extract-plugin
export var layoutContainer = "_dl-0";
export var layoutContainerNoRounding = "_dl-6";
export var layoutContainerOpen = "_dl-5";
export var layoutContainerResizing = "_dl-1";
export var mainContent = "_dl-2";
export var resizeDivider = "_dl-3";
export var slidePanel = "_dl-4";